export function accordionToggle(btn, content) {
	// Toggle button open
	if (btn.getAttribute('data-toggle') === 'closed') {
		btn.setAttribute('aria-expanded', true);
		btn.setAttribute('data-toggle', 'open');
		btn.classList.add('accordion-open');
		content.setAttribute('aria-hidden', false);
		content.style.maxHeight =
			content.querySelector('.accordion-content-inner').offsetHeight +
			'px';
	}
	// Toggle button close
	else {
		btn.setAttribute('aria-expanded', false);
		btn.setAttribute('data-toggle', 'closed');
		btn.classList.remove('accordion-open');
		content.setAttribute('aria-hidden', true);
		content.style.maxHeight = null;
	}
}
